import APIClient from '@/shared/http/clients/api'

const resourceName = 'VistoriaEpi'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetByVistoria = (vistoriaId, limit, index, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/vistoria/${vistoriaId}?limit=${limit}&index=${index}`, data, config)
const vistoriaPDF = (vistoriaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/vistoriaPDF/${vistoriaId}`, data, config)
const vistoriapdfmob = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/vistoriapdfmob`, data, config)
const SetImg = (iD, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/img/${iD}`, data, config)
const PutVistoriaAndApiEpi = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/vitoriaandepi`, data, config)

const SurveyEpiRepository = {
  GetByVistoria,
  SetImg,
  PutVistoriaAndApiEpi,
  vistoriaPDF,
  vistoriapdfmob
}
export default SurveyEpiRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/surveyEquipment.js